/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import React from 'react';

import { useIntl } from 'react-intl';

import IconButton from '@atlaskit/button/icon/button';
import type { IconButtonProps } from '@atlaskit/button/icon/button';
import { jsx } from '@atlaskit/css';
import RetryIcon from '@atlaskit/icon/core/retry';

import messages from './messages';

type Props = {
	appearance?: IconButtonProps['appearance'];
	isDisabled?: boolean;
	onClick: (event: React.MouseEvent) => void;
	spacing?: IconButtonProps['spacing'];
	tabIndex?: number;
};
export const RetryIconButton = ({
	onClick,
	tabIndex,
	appearance,
	spacing,
	isDisabled = false,
}: Props): JSX.Element => {
	const { formatMessage } = useIntl();
	const tooltip = formatMessage(messages.retryPrompt);

	const tooltipOptions: IconButtonProps['tooltip'] = {
		position: 'top',
		hideTooltipOnClick: true,
		content: tooltip,
	};

	return (
		<IconButton
			testId="retry-prompt-button"
			type="button"
			onClick={onClick}
			icon={RetryIcon}
			label={tooltip}
			appearance={appearance}
			spacing={spacing}
			tabIndex={tabIndex}
			isTooltipDisabled={false}
			tooltip={tooltipOptions}
			isDisabled={isDisabled}
		/>
	);
};
